export const $ = document.querySelector.bind(document);
export const $$ = document.querySelectorAll.bind(document);

// Check if an element is in the viewport
export const isInViewport = (element) => {
    const imgSpace = element.getBoundingClientRect();
    return imgSpace.top >= 0 && imgSpace.bottom <= (window.innerHeight || document.documentElement.clientHeight);
};

/**
 * Run a callback once the DOM is ready. If DOM is already loaded, runs it immediately.
 * @param {() => void | Promise<void>} callback
 */
export const runOnDomReady = (callback) => {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => void callback());
    } else {
        void callback();
    }
};

/**
 * Build application CTA query params from scratch.
 * Preserves utm_* and raf_id from the source params, adds city (lowercase) and page param.
 *
 * @param {URLSearchParams} sourceParams - The params to extract utm/raf_id from
 * @returns {URLSearchParams}
 */
export const buildApplicationCtaParams = (sourceParams) => {
    const freshParams = new URLSearchParams();

    // Preserve all utm_* params and raf_id
    sourceParams.forEach((value, key) => {
        if (/^utm_/.test(key) || key === 'raf_id') {
            freshParams.set(key, value);
        }
    });

    // Set city (always lowercase)
    const city = window.salarySliderCity || window.currentCity?.slug || null;
    if (city) {
        freshParams.set('city', city.toLowerCase());
    }

    // Set page param based on page type
    if (window.page === 'home_city') {
        freshParams.set('page', city ? 'city' : 'landing_page');
    }

    return freshParams;
};
